import React from 'react'
import VirtualCardsNeedsApproval from 'src/app/VirtualCardsNeedsApproval/VirtualCardsNeedsApproval'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { virtualCardsNeedsApprovalRouteProps } from 'src/navigation/routeProps'

const VirtualCardsNeedsApprovalAppRoute: AppRoute = {
  id: AppLocation.VirtualCardsNeedsApproval,
  routeProps: virtualCardsNeedsApprovalRouteProps,
  component: <VirtualCardsNeedsApproval />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default VirtualCardsNeedsApprovalAppRoute
